import styled from "styled-components";

export const TrackListStyled = styled.div`
  margin-top: 20px;
`;
